import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
    providedIn: "root",
})

export class Authenticationservice {
    decryptedInfo;
    public userdata: any;
    Authention(): {} {
        //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
        //Add 'implements OnInit' to the class.
        let data = localStorage.getItem('userdata');
        if (data) {
            var deData = CryptoJS.AES.decrypt(decodeURIComponent(data), 'bsfdev');
            this.decryptedInfo = JSON.parse(deData.toString(CryptoJS.enc.Utf8));
            this.userdata = this.decryptedInfo.alldata[0];
            return this.userdata;
        }
        else
            return {};
    }

    dataalert;

    Alertreload(): void {
        let dataalert2 = localStorage.getItem('dataalert');
        this.dataalert = JSON.parse(dataalert2);
        return this.dataalert;
    }

    DatetoLocal(thisdate: any) {
        const date1 = new Date(thisdate);
        let options: any = {
            // weekday: "short",
            year: "numeric",
            month: "numeric",
            day: "numeric",
        };

        return date1.toLocaleString('th-TH', options);
    }

}